export const BYTES_IN_MB = 1024 * 1024;
export const MAX_IMAGE_FILE_SIZE_MB = 2;
export const mbToBytes = (mb: number) => mb * BYTES_IN_MB;
